const certificateProductListGridColumns = [
  {
    id: 'modelName',
    value: 'Model Name',
    selected: false,
    orderBy: '',
    isShown: true,
    isFrozen: true,
    width: '150px',
    orderNo: 1,
  },
  {
    id: 'status',
    value: 'Model Status',
    selected: false,
    orderBy: '',
    isShown: true,
    isFrozen: false,
    width: '80px',
    orderNo: 2,
  },
  {
    id: 'ownerName',
    value: 'Applicant/Owner Name',
    selected: false,
    orderBy: '',
    isShown: true,
    isFrozen: false,
    width: '55px',
    orderNo: 3,
  },

  {
    id: 'projectNumber',
    value: 'Project Number',
    selected: false,
    orderBy: '',
    isShown: true,
    isFrozen: false,
    width: '55px',
    orderNo: 4,
  },
  {
    id: 'collectionName',
    value: 'Collection Name',
    selected: false,
    orderBy: '',
    isShown: true,
    isFrozen: false,
    width: '55px',
    orderNo: 5,
  },
  {
    id: 'collectionStatus',
    value: 'Collection Status',
    selected: false,
    orderBy: '',
    isShown: true,
    isFrozen: false,
    width: '55px',
    orderNo: 6,
  },
  {
    id: 'modelNomenclature',
    value: 'Model Nomenclature',
    selected: false,
    orderBy: '',
    isShown: true,
    isFrozen: false,
    width: '55px',
    orderNo: 7,
  },
  {
    id: 'productType',
    value: 'Product Type',
    selected: false,
    orderBy: '',
    isShown: true,
    isFrozen: false,
    width: '55px',
    orderNo: 8,
  },
  {
    id: 'referenceNumber',
    value: 'Reference Number (ex. File Number)',
    selected: false,
    orderBy: '',
    isShown: true,
    isFrozen: false,
    width: '55px',
    orderNo: 9,
  },
  {
    id: 'familySeries',
    value: ' Family/Series',
    selected: false,
    orderBy: '',
    isShown: true,
    isFrozen: false,
    width: '100px',
    orderNo: 10,
  },
  {
    id: 'creationDate',
    value: 'Creation Date',
    selected: false,
    orderBy: '',
    isShown: true,
    isFrozen: false,
    width: '55px',
    orderNo: 11,
  },
  {
    id: 'actionsColumnTab',
    value: '',
    selected: false,
    orderBy: '',
    isShown: true,
    isFrozen: true,
    width: '20px',
    orderNo: 12,
  },
]

export default certificateProductListGridColumns
